import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col',
    dialog:
      'py-12 max-md:px-3 max-md:py-6 sm:w-[680px] sm:px-16 sm:py-16 lg:pt-16',
    dialogCloseIcon: 'size-10',
    title: 'heading-2xl md:heading-3xl mb-8',
    closeButton: 'heading-xs mb-3 flex items-center gap-2',
    closeButtonIcon: 'size-6 rotate-90'
  }
});
